import {
  Button,
  Flex,
  IconMegaphone,
  Modal,
  ModalButton,
  ModalContent,
  ModalDismiss,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Text,
  TextArea,
  Tooltip,
  csx,
  useModalState,
} from '@vtex/admin-ui'
import { useAdmin } from '@vtex/raccoon-next'
import { useAdminUser } from 'hooks'
import { useEffect, useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'

const messages = defineMessages({
  tooltip: { id: 'admin/promotions.form.feedback.tooltip' },
  title: { id: 'admin/promotions.form.feedback.title' },
  question: { id: 'admin/promotions.form.feedback.question.experience' },
  comments: { id: 'admin/promotions.form.feedback.question.comments' },
  cancel: { id: 'admin/promotions.utils.cancel' },
  send: { id: 'admin/promotions.form.feedback.send' },
})

const RATINGS = {
  '1': '😖',
  '2': '🙁',
  '3': '🙂',
  '4': '😃',
  '5': '🤩',
}

export function Feedback() {
  const modal = useModalState()
  const { formatMessage: i18n } = useIntl()
  const [rate, setRate] = useState<keyof typeof RATINGS | undefined>(undefined)
  const [comment, setComment] = useState('')
  const { account } = useAdmin()
  const { data: { email } = {} } = useAdminUser()

  useEffect(() => {
    if (modal.open) {
      setRate(undefined)
      setComment('')
    }
  }, [modal.open])

  const send = () => {
    fetch('https://hooks.zapier.com/hooks/catch/9785621/2y4hz1j/', {
      method: 'POST',
      body: JSON.stringify({
        account,
        email,
        rate,
        comment,
        date: new Date().toString(),
      }),
    })
  }

  return (
    <>
      <Tooltip text={i18n(messages.tooltip)}>
        <Button
          onClick={modal.toggle}
          aria-label={i18n(messages.tooltip)}
          variant="neutralTertiary"
          className={csx({ svg: { color: '$action.main.secondary' } })}
          size="large"
          icon={<IconMegaphone />}
        />
      </Tooltip>
      <Modal state={modal}>
        <ModalHeader>
          <ModalTitle>{i18n(messages.title)}</ModalTitle>
          <ModalDismiss />
        </ModalHeader>
        <ModalContent className={csx({ paddingTop: 0 })}>
          <Text>{i18n(messages.question)}</Text>
          <Flex
            className={csx({
              gap: '$space-3',
              width: 'full',
              justifyContent: 'center',
              marginTop: '$space-4',
              marginBottom: '$space-6',
            })}
          >
            {Object.entries(RATINGS).map(([key, value]) => (
              <Button
                key={key}
                variant={rate === key ? 'secondary' : 'tertiary'}
                onClick={() => setRate(key)}
                className={csx({ '&&': { height: 'auto' } })}
              >
                <Text variant="display">{value}</Text>
              </Button>
            ))}
          </Flex>
          <TextArea
            label={i18n(messages.comments)}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </ModalContent>
        <ModalFooter>
          <ModalButton variant="secondary" dismissModal>
            {i18n(messages.cancel)}
          </ModalButton>

          <ModalButton onClick={send} dismissModal disabled={!rate}>
            {i18n(messages.send)}
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  )
}
